import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import { getmessage,wrongmsg } from './Dynamictable';
import axios from 'axios';

import Configdata from './Defaultdata';
import './home.css';

import './cube.css';

export default class Applysaleexecutive extends Component {
    state = {
        name: "World",
        type: "1",
        Phone: null,
        msg: "",
        typeoption: null,
        expoption: null,
        catoption: null,
        bindopt: null,
        isVisible: true,
        resm: null,
        url: "",
        walk: "",
        citywalk:"",
        tpb: null,
        opening: [{}]
    };

   
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
     
        //this.Homehitcount();
        this.setserverurl();
       
     
    };
	typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		if(eid == 'Close')
		{
		 var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		
		maindiv.style.display = 'none';
		Pdivr.style.display = 'block';
		

		}
		else if(eid == 'acceptandapply'){
		this.applyforsales();
		}
		

		e.preventDefault()

	};
	applyforsales(){

	try {
		getmessage('On Process Please wait.....','');
		
		const token =  localStorage.getItem("id") ;
		
                const response = axios.post(Configdata.srvurl + '/applysalesexcutive', {
    		
    		procode: token
		
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		
		if(usercd == null || usercd == 'NA')
		getmessage('Somthing went Wrong','');
		
		else{
		
		getmessage(usercd,'');
	        } 
	        });		
              }
		
	   
          }
        catch (e) {
           // debugger;
		//wrongmsg();
        }


	}
    
    
 render() {

   
     return (

         <form>
	<div className="per100" id="applypost" style={{height:'100vh',overflowY: 'auto',overflowX: 'hidden'}}>
	 
	<div className="homecube" style={{marginTop:'8vh'}}>
               <div style={{width:'100vw',padding:'0px',margin:'0px'}}> 
		  <div style={{width:'80vw'}}> 
			<b>Benifits of sales executive</b>
		  </div>

		</div>
		<ul style={{marginTop:'2px'}}>
		<li>One time 500 points will be given 
		</li>
		<li> Access permission to display posting towards top
		</li>
		<li> You will be paid 50% of your ads or posting revenue on portal
		</li>
		<li> You will be paid 20% of other ads collecting
		</li>
		<li> Achieving 2 days guest in ooty/naintal for 5 days minimum ads collecting
		</li>
		<li> For direct sale of Property commission will be paid up to 5% (varies from 0.5% to 5%) 
		</li>
		<li> For 50 thousand business from your account providing 2 persons 2 nights guest at ooty
		</li>
		<li> For your 60 thousand income within a year will be provided you ESI
		</li>
		<li> For 10 lakhs business from your account providing 2 persons 2 nights guest at darjeeling
		</li>
		<li> For 20 lakhs business from your account providing 2 persons 2 nights at 5 star hotel in goa
		</li>
		<li> For 40 lakhs business from your account providing 2 persons 3 days visiting near by foreign tours and become silver member
		</li>
		<li> After 3 month business calculated for gold,emerald and diamond member 
		</li>
		<li> minimum 50 lakhs getting business from your account be gold member
		</li>
		<li> minimum 1 crore business from your account be emerald member 
		</li>
		<li> emerald member will be fixed salary according your business minimum Rs 10000 per month
		</li>
		<li> diamond member will be gifted a 2 BHK flat in the corresponding city.
		</li>
		<li> diamond member will be fixed salary according your business minimum Rs 100000 per month
		</li>
		<li> Extra income from service salering after integrate with the app.
		</li>
		<li> Getting income from third party if added with apps in future
 		</li>

       
		</ul>

		 <div style={{width:'100vw',marginTop:'0px'}}> 
		  <div style={{width:'80vw'}}> 
			<b>Criteria for Sales executive</b>
		  </div>
	        <ul style={{marginTop:'0px'}}>
		<li> minimum qualification 12th pass
		</li>
		<li> Five referral users
		</li>
		<li> obey the Indian IT and digital public online rules .If any dipute arise shall be subject to the juridiction of the courts of Bengaluru,India
		</li>
		</ul>
                <div className="sidebar-basic-info"  style={{width:'100%',height:'10px',margin:'0px',padding:'0px'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="close" style={{marginTop:'0px',padding:'0px'}}>

			<div className="searchtype" id="Close" style={{backgroundColor:'green',margin:'0px',padding:'0px'}} >
			  Close	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="apply" style={{margin:'0px',padding:'0px'}}>

			<div className="searchtype" id="acceptandapply" style={{marginTop:'0px',padding:'0px'}}>
			accepted and Join
			</div>
			</a>
	       </div>	
		</div>

		
		
	</div>
        <div>
		

	</div>
	<div>
		

	</div>
	</div>
   	</form>
    
   
      );
}
}

